<script setup lang="ts">
import { intersectObserver } from '@/helpers/intersectObserver'
import { onMounted, ref } from 'vue'
const props = defineProps({
  src: {
    type: String,
    default: '',
  },
})
const $target = ref()
const imageSrc = ref()
const imageShow = ref(false)
onMounted(() => {
  intersectObserver({
    element: $target.value,
    callback: [
      () => {
        const image = new Image()
        const imgUrl = props.src
          ? (!props.src.startsWith('http') && !props.src.startsWith('//')
              ? `//${import.meta.env.VITE_APP_CDN_HOST}`
              : '') + props.src
          : ''

        image.src = imgUrl
        image.onload = () => {
          imageSrc.value = imgUrl
          setTimeout(() => {
            imageShow.value = true
          }, 10)
        }
      },
    ],
  })
})
</script>
<template>
  <div
    ref="$target"
    class="lazyloadimg"
    :class="{ show: imageShow }"
    :style="{ backgroundImage: `url(${imageSrc})` }"
  ></div>
</template>
<style scoped lang="scss">
.lazyloadimg {
  // opacity: 0;
  transition: opacity 0.3s;
  position: relative;
  &.show {
    // opacity: 1;
    &:before {
      opacity: 0;
    }
  }
  &:before {
    content: '';
    position: absolute;
    transition: opacity 0.3s;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: white;
    width: 101%;
    height: 101%;
    background: url('@/assets/imgs/common/loading.gif') white no-repeat center center / 100px 100px;
    z-index: 3;
  }
}

@media #{$tablet} {
  .lazyloadimg {
    &:before {
      background-size: 70px 70px;
    }
  }
}
@media #{$mobile} {
  .lazyloadimg {
    &:before {
      background-size: 50px 50px;
    }
  }
}
</style>
